import { CardCarousel } from "./card-carousel.js";
const collectionCarousels = document.querySelectorAll('.featured-collection__carousel');
collectionCarousels?.forEach(el => new CardCarousel(el));
